<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-infinity"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="process.arrangement"
                    filled
                    label="Số thứ tự "
                    placeholder="Nhập số thứ tự"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="process.name"
                    filled
                    label="Name"
                    placeholder="Enter name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Description</div>
                <ck-content class="ck-content" :content="process.description"
                            @getData="value => process.description = value"></ck-content>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="process.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="mb-4">Mô tả</div>
                <ck-content class="ck-content" :content="process.description_vi"
                            @getData="value => process.description_vi = value"></ck-content>
              </v-col>
            </v-col>
          </v-row>
          <v-col cols="12" class="text-center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {SAVE_PROCESS} from "@/store/modules/process";
import CkContent from "@/components/ck-content";

export default {
  name: "Add_process",
  components: {
    CkContent,
  },
  data() {
    return {
      page: "Thêm process",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách process",
          disabled: true,
        },
        {
          text: "Thêm process",
          disabled: false,
        },
      ],
      process: {
        name: '',
        name_vi: '',
        description: '',
        description_vi: '',
        active: 0,
        arrangement: ''
      }
    }
  },
  methods: {
    async save() {
      let data = {
        name: this.process.name,
        name_vi: this.process.name_vi,
        description: this.process.description,
        description_vi: this.process.description_vi,
        arrangement: this.process.arrangement,
        active: this.process.active
      }
      await this.$store.dispatch(`${SAVE_PROCESS}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/process')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>